import React, { useEffect, useState } from 'react';
import { Menu, X, Download } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'How It Works',
    href: '/#how-it-works'
  }, {
    name: 'Features',
    href: '/#features'
  }, {
    name: 'Blog',
    href: '/blog'
  }, {
    name: 'Guides',
    href: '/guides/how-to-scan-pantry'
  }, {
    name: 'About',
    href: '/about'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || isMobileMenuOpen ? 'bg-white/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-2816" data-mp="9ozekczdrnws">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2817" data-mp="jm3zyalejfcj">
        <div className="flex items-center justify-between" data-id="element-2818" data-mp="jkt0uo2wivrr">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 group" data-id="element-2819" data-mp="okysw5d32kad">
            <img src="https://cdn.magicpatterns.com/uploads/kYypn9DLGTyuEjc1d2cJka/intellieats_icon.webp" alt="IntelliEats icon" className="h-10 w-10 rounded-xl shadow-lg group-hover:shadow-brand-200/50 transition-all duration-300" data-id="element-2820" data-mp="3n4oz2r2esqte" />
            <span className="text-xl font-bold text-slate-900 tracking-tight" data-id="element-2821" data-mp="5nxoomrcso7h">
              Intelli<span className="text-brand-600" data-id="element-2822" data-mp="34de869wooe1i">Eats</span>
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-2823" data-mp="39ao8iklm2a44">
            {navLinks.map(link => link.href.startsWith('/#') ? <a key={link.name} href={link.href} className="text-sm font-medium text-slate-600 hover:text-brand-600 transition-colors" data-id="element-2824" data-mp="2wc6mao6xofqb">
                  {link.name}
                </a> : <Link key={link.name} to={link.href} className="text-sm font-medium text-slate-600 hover:text-brand-600 transition-colors" data-id="element-2825" data-mp="3642wgxmanwaw">
                  {link.name}
                </Link>)}
            <a href="/#download" className="inline-flex items-center px-5 py-2.5 text-sm font-semibold text-white bg-brand-600 rounded-full hover:bg-brand-700 transition-colors shadow-lg shadow-brand-200/50 hover:shadow-brand-300/50 transform hover:-translate-y-0.5 duration-200" data-id="element-2826" data-mp="2sbwfxaf8bnax">
              <Download className="w-4 h-4 mr-2" data-id="element-2827" data-mp="a4sctm4asl43" />
              Download Free
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-2828" data-mp="f4oidpsn8klr">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 text-slate-600 hover:text-brand-600 transition-colors" aria-label="Toggle menu" data-id="element-2829" data-mp="f1isi8c6xeoz">
              {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-2830" data-mp="swl5fffgg4ba" /> : <Menu className="h-6 w-6" data-id="element-2831" data-mp="xu3fj957kpkv" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-2832" data-mp="k2gk1bj3bl35">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-slate-100 overflow-hidden" data-id="element-2833" data-mp="o41ruigrp96h">
            <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-2834" data-mp="3k33wz5jpin6b">
              {navLinks.map(link => link.href.startsWith('/#') ? <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-3 text-base font-medium text-slate-600 hover:text-brand-600 hover:bg-brand-50 rounded-lg transition-colors" data-id="element-2835" data-mp="3f49i2eov1irh">
                    {link.name}
                  </a> : <Link key={link.name} to={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-3 text-base font-medium text-slate-600 hover:text-brand-600 hover:bg-brand-50 rounded-lg transition-colors" data-id="element-2836" data-mp="1voap9vt44tw">
                    {link.name}
                  </Link>)}
              <div className="pt-4" data-id="element-2837" data-mp="28bmp0a0e80xs">
                <a href="/#download" onClick={() => setIsMobileMenuOpen(false)} className="flex items-center justify-center w-full px-5 py-3 text-base font-semibold text-white bg-brand-600 rounded-xl hover:bg-brand-700 transition-colors shadow-lg" data-id="element-2838" data-mp="2d84tr9vq3za4">
                  <Download className="w-5 h-5 mr-2" data-id="element-2839" data-mp="2r7csy2rvz7eb" />
                  Download Free
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}